<template>
  <div class="chat-list d-flex flex-column h-100">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 class="mb-0">Conversations</h6>
      <button type="button" class="btn btn-sm btn-primary" @click="$emit('new-chat')">
        <i class="bi bi-pencil-square"></i> New
      </button>
    </div>
    <div v-if="!conversations.length" class="text-muted small fst-italic">
      No conversations yet.
    </div>
    <div v-else class="list-group list-group-flush overflow-auto">
      <button
        v-for="conv in conversations"
        :key="conv.id"
        type="button"
        class="list-group-item list-group-item-action py-2"
        :class="{ active: String(conv.id) === String(selectedId) }"
        @click="$emit('select', conv)"
      >
        <div class="text-truncate fw-semibold">{{ conversationTitle(conv) }}</div>
        <small class="d-block text-muted">
          <i class="bi bi-clock me-1"></i>{{ formatDate(conv) }}
        </small>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatList',
  props: {
    conversations: { type: Array, default: () => [] },
    selectedId: { type: [String, Number], default: null },
  },
  emits: ['select', 'new-chat'],
  methods: {
    conversationTitle(conv) {
      if (conv && typeof conv.title === 'string' && conv.title.trim()) {
        return conv.title;
      }
      const messages = (conv && conv.messages) || [];
      const firstUser = messages.find((m) => m.role === 'user' && m.content);
      const text = (firstUser && firstUser.content) || '';
      const trimmed = text.trim();
      if (!trimmed) {
        return 'Untitled chat';
      }
      return trimmed.length > 40 ? `${trimmed.slice(0, 40)}…` : trimmed;
    },
    formatDate(conv) {
      const raw = (conv && (conv.updated_at || conv.created_at)) || '';
      if (!raw) {
        return '';
      }
      return new Date(raw).toLocaleString();
    },
  },
};
</script>
